import experienceStrategy from './enhancedExperienceStrategy';
import skillsStrategy from './skillsStrategy';
import locationStrategy from './locationStrategy';
import locationQueueStrategy from './locationQueueStrategy';
import titleStrategy from './titleStrategy';
import candidatePreviewStrategy from './candidatePreviewStrategy';
import companyStrategy from './companyStrategy';
import companyQueueStrategy from './companyQueueStrategy';
import companyStageStrategy from './companyStageStrategy';
import educationQueueStrategy from './education';
import defaultStrategy from './defaultStrategy';
import businessModelStrategy from './businessModel';
import businessModelQueueStrategy from './businessModelQueueStrategy';
import companySizeQueueStrategy from './companySizeQueueStrategy';
import keywordsStrategy from './keywordsStrategy';

// Export individual strategies for direct imports
export {
  experienceStrategy,
  skillsStrategy,
  locationStrategy,
  locationQueueStrategy,
  titleStrategy,
  candidatePreviewStrategy,
  companyStrategy,
  companyQueueStrategy,
  companyStageStrategy,
  businessModelStrategy,
  businessModelQueueStrategy,
  companySizeQueueStrategy,
  educationQueueStrategy,
  keywordsStrategy,
  defaultStrategy
};

// Define the base strategies for all role types
const baseStrategies = {
  experience: experienceStrategy,
  skills: skillsStrategy,
  location: locationQueueStrategy, // Use queue-driven location strategy
  title: titleStrategy,
  candidate_preview: candidatePreviewStrategy,
  company: companyStrategy,
  companies: companyQueueStrategy, // Use queue-driven companies strategy
  company_stage: companyStageStrategy,
  company_biz_model: businessModelQueueStrategy, // Use queue-driven business model strategy
  business_model: businessModelQueueStrategy, // Use queue-driven business model strategy
  company_size: companySizeQueueStrategy, // Use queue-driven company size strategy
  education: educationQueueStrategy, // Use queue-driven education strategy
  keywords: keywordsStrategy, // Use keywords strategy
  default: defaultStrategy
};

// Role-specific strategy overrides could be defined here
// For example, if TECHNICAL roles needed a different skills strategy:
// const technicalStrategies = {
//   ...baseStrategies,
//   skills: technicalSkillsStrategy
// };

/**
 * Get the appropriate strategy based on topic and role type
 * @param {string} topic - The topic to get a strategy for
 * @param {string} roleType - The role type (TECHNICAL, CREATIVE, etc.)
 * @returns {Function} The strategy function to use
 */
export const getStrategyForRoleType = (topic, roleType) => {
  // Currently we use the same strategies for all role types
  // This function allows for future expansion to role-specific strategies
  
  // Log the strategy selection
  console.log(`Getting strategy for topic: ${topic}, role type: ${roleType}`);
  
  // Special logging for keywords topic
  if (topic === 'keywords') {
    console.log('🎯🎯🎯 KEYWORDS TOPIC REQUESTED!!! - Checking baseStrategies...');
    console.log('🎯 Available strategies:', Object.keys(baseStrategies));
    console.log('🎯 Keywords strategy exists:', !!baseStrategies.keywords);
    console.log('🎯 Keywords strategy:', baseStrategies.keywords);
    console.log('🎯 Keywords strategy name:', baseStrategies.keywords?.name);
    console.log('🎯 Current timestamp for debugging cache:', new Date().toISOString());
  }
  
  // Check if the topic exists in baseStrategies
  if (!topic) {
    console.warn('No topic provided to getStrategyForRoleType, returning null (no strategy)');
    return null;
  }
  
  const strategy = baseStrategies[topic];
  if (!strategy) {
    console.warn(`No strategy found for topic "${topic}", returning null to allow auto-advance`);
    if (topic === 'keywords') {
      console.error('🎯🎯🎯 KEYWORDS STRATEGY NOT FOUND!!! This is a critical error!');
    }
    return null;
  }
  
  console.log(`Found strategy for topic "${topic}": ${strategy.name || 'unnamed strategy'}`);
  
  if (topic === 'keywords') {
    console.log('🎯🎯🎯 KEYWORDS STRATEGY FOUND AND RETURNING!!!');
  }
  
  // Return the appropriate strategy
  return strategy;
};

// Export the default strategies object for backward compatibility
export default baseStrategies;
